module.exports = __webpack_public_path__ + "img/step-peo-active.cebc0dfb.png";